
// jQuery ya lo tienes
import jQuery from 'jquery';
window.$ = jQuery;

// Importamos CSS y JS de Bootstrap
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap; // Muy importante para usar bootstrap.Modal globalmente

// Otros requires existentes
require('showdown');

// Flatpickr
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import { Spanish } from "flatpickr/dist/l10n/es.js";

flatpickr(".datepicker", {
    locale: Spanish,
    dateFormat: "Y-m-d",
    allowInput: true,
    clickOpens: true
});

window.showBootstrapAlert = function(message, type = 'info', timeout = 4000) {
    // Crear contenedor si no existe
    let alertContainer = document.getElementById('alertContainer');
  
    const wrapper = document.createElement('div');
    wrapper.innerHTML = `
        <div class="alert alert-${type} alert-dismissible fade show" role="alert">
            ${message}
            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        </div>
    `;
    alertContainer.innerHTML = '';
    alertContainer.append(wrapper);

    // Desaparece automáticamente
    setTimeout(() => {
        const alertNode = document.querySelector('.alert');

    if (alertNode) {
        const alert = bootstrap.Alert.getOrCreateInstance(alertNode);
        alert.close();
    }
    }, timeout);
};

window.togglePassword = function () {
    const input = document.getElementById('password');
    const icon = document.getElementById('toggleIcon');

    if (input.type === 'password') {
        input.type = 'text';
        icon.classList.remove('bi-eye');
        icon.classList.add('bi-eye-slash');
    } else {
        input.type = 'password';
        icon.classList.remove('bi-eye-slash');
        icon.classList.add('bi-eye');
    }
}
